﻿import { TextLanguages } from '../Text/TextContent';

// Get a valid language code supported by the widget.  Currently this is English or Spanish.
// 
// props.language contains the language code passed by the consumer. It can be undefined in
// which case English is used.  
//
// Return value is always a language code that is actually supported by the widget, i.e. it can
// be used as a parameter to the constructor for TextContent.

export const GetClosestValidLanguage = (language?: string): TextLanguages => {
    if (!language) {
        return 'en';
    }

    // split will generate an array of at least 1 element.
    const languagePieces = language.split('-');

    // At the moment just returning the highest level value of a language meaning we aren't
    // delineating between local dialects, e.g. 'es-ar' (Argentinian Spanish) will just resolve
    // to 'es'.

    return (languagePieces[0] === 'es') ? 'es' : 'en';
}
